/* eslint-disable react-hooks/exhaustive-deps */
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import { Font } from "@react-pdf/renderer";
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Rudaw from '../../../../assets/fonts/rudawregular2.ttf';
import PagePaymentService from '../../../../services/pagePaymentService';
import { useCompany } from '../../../../provider/companyProvider';
import { wrap } from 'comlink';



// ✅ Modern worker import (Webpack 5 / Vite)
const worker = new Worker(new URL('./pdfOnePagePaymentWorker.js', import.meta.url));
const workerApi = wrap(worker);

const registerFont = () => {
  Font.register({
    family: 'Rudaw',
    fonts: [{ src: Rudaw, fontWeight: 'normal' }],
  });
};

const PdfOnePagePayment = ({ id }) => {
  const { i18n, t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { business } = useCompany();

  const handlePrint = async () => {
    registerFont();
    setIsLoading(true);

    try {
      // Fetch data
      const data = await PagePaymentService.fetchOne(id);
      const pagePaymentData = JSON.parse(JSON.stringify(data)); // serialize safely


      const translations = {
        pagePaymentInfo: t('pagePaymentInfo'),
        id: t('id'),
        pageName: t('pageName'),
        priceAmount: t('priceAmount'),
        note: t('note'),
        branch: t('branch'),
        user: t('user'),
        createdAt: t('createdAt'),
        currentDate: t('currentDate'),
        number: t('number'),
        invoiceNumber: t('invoiceNumber'),
        receiverPhone: t('receiverPhoneTable'),
        address: t('address'),
        totalPrice: t('totalPrice'),
        transportationPrice: t('transportationPrice'),
        netPrice: t('netPrice'),
        date: t('date'),
        totalItems: t('totalItems'),
        totalPostAmount: t('totalPostAmount'),
        totalTransportationAmount: t('totalTransportationAmount'),
        netPostAmount: t('netPostAmount'),
      };

      // Generate PDF
      const blobUrl = await workerApi.renderPDF({
        pagePayment: pagePaymentData,
        business,
        t: translations,          // pass translation fn
        language: i18n.language,
      });
      window.open(blobUrl);
    } catch (error) {
      console.error("Error generating PDF in worker:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading
    ? <CircularProgress size={20} />
    : <LocalPrintshopOutlinedIcon sx={{ cursor: 'pointer' }} fontSize='small' onClick={handlePrint} />;
};

export default PdfOnePagePayment;